/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import { getCurrentUser } from 'state/current-user/selectors';
import { Stack } from '@towersystems/towersystems-design-system';
import DetailListItem from 'components/detail-list-item';
import Card from 'components/card';
import DateTime from 'components/date-time';

const RoamDetailsCard = ({ roamType, roamExpiry, additionalLicenses }) => {
	return (
		<Card>
			<Stack>
				<Card.Section>
					<DetailListItem label='Roam expiry date' detail={<DateTime date={roamExpiry} format='Do MMM, YYYY' />} />
				</Card.Section>
			</Stack>
		</Card>
	);
};

export default connect((state) => {
	let user = getCurrentUser(state);
	return {
		roamType: user && user.roamType,
		additionalLicenses: user && user.additionalLicenses,
		roamExpiry: user && user.sugarRoamExpiry,
	};
}, {})(RoamDetailsCard);
